module.exports = __webpack_public_path__ + "static/img/BIANC.2a42dcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/BIANC.png
// module id = CDUb
// module chunks = 1